import {
  ROOM_TYPE_PREVIEW,
  ROOM_TYPE_NEW,
  ROOM_TYPE_UPDATE,
  ROOM_TYPE_REMOVE,
  ROOM_TYPE_PROCESS_SUCCESS,
  ROOM_TYPE_DATASOURCE_SUCCESS,
  ROOM_TYPE_SEARCH,
  ROOM_TYPE_PROCESS_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ROOM_TYPE_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case ROOM_TYPE_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case ROOM_TYPE_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case ROOM_TYPE_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case ROOM_TYPE_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case ROOM_TYPE_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case ROOM_TYPE_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case ROOM_TYPE_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}